(function () {
  'use strict';

  function money(cents) {
    var n = (cents / 100).toFixed(0);
    return '\u20B9' + n.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* Header scroll */
  var header = document.getElementById('site-header');
  function onScroll() {
    if (!header) return;
    if (window.scrollY > 10) header.classList.add('scrolled');
    else header.classList.remove('scrolled');
  }
  window.addEventListener('scroll', onScroll);
  onScroll();

  /* Mobile nav */
  var mnav = document.getElementById('mobile-nav');
  var overlay = document.getElementById('overlay');
  var ham = document.getElementById('ham-btn');
  var mclose = document.getElementById('mnav-close');
  function openNav() { mnav.classList.add('open'); overlay.classList.add('open'); }
  function closeAll() {
    if (mnav) mnav.classList.remove('open');
    var d = document.getElementById('cart-drawer');
    if (d) d.classList.remove('open');
    overlay.classList.remove('open');
  }
  if (ham) ham.addEventListener('click', openNav);
  if (mclose) mclose.addEventListener('click', closeAll);
  if (overlay) overlay.addEventListener('click', closeAll);

  /* Cart drawer */
  var drawer = document.getElementById('cart-drawer');
  var cartToggle = document.getElementById('cart-toggle');
  var cartClose = document.getElementById('cart-close');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('open');
    overlay.classList.add('open');
    refreshDrawer();
  }
  if (cartToggle) {
    cartToggle.addEventListener('click', function (e) {
      if (window.CJP && window.CJP.useDrawer) { e.preventDefault(); openDrawer(); }
    });
  }
  var mobileCart = document.getElementById('mobile-cart');
  if (mobileCart) {
    mobileCart.addEventListener('click', function (e) {
      if (window.CJP && window.CJP.useDrawer) { e.preventDefault(); openDrawer(); }
    });
  }
  if (cartClose) cartClose.addEventListener('click', closeAll);

  function refreshDrawer() {
    fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderDrawer(cart); });
  }

  function renderDrawer(cart) {
    var items = document.getElementById('drawer-items');
    var foot = document.getElementById('drawer-foot');
    var shipBar = document.getElementById('ship-bar');
    if (!items) return;

    updateCount(cart.item_count);

    if (cart.item_count === 0) {
      items.innerHTML = '<div class="cart-drawer__empty"><p>Your cart is empty</p><a href="/collections/all" class="btn btn--primary">Start shopping</a></div>';
      if (foot) foot.innerHTML = '';
      if (shipBar) shipBar.innerHTML = '';
      return;
    }

    var html = '';
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      html += '<div class="cart-drawer__item">';
      html += '<img src="' + (it.image ? it.image.replace(/(\.[^.]*)$/, '_120x$1') : '') + '" alt="">';
      html += '<div><div class="cart-drawer__item-title">' + it.product_title + '</div>';
      if (it.variant_title) html += '<div class="cart-drawer__item-meta">' + it.variant_title + '</div>';
      html += '<div class="cart-drawer__qty"><button onclick="CJPCart.change(\'' + it.key + '\',' + (it.quantity - 1) + ')">&minus;</button><span>' + it.quantity + '</span><button onclick="CJPCart.change(\'' + it.key + '\',' + (it.quantity + 1) + ')">+</button></div></div>';
      html += '<div style="text-align:right;"><div style="font-weight:600;font-family:var(--font-display);">' + money(it.final_line_price) + '</div><button class="cart-item__remove" style="margin:6px 0 0;" onclick="CJPCart.change(\'' + it.key + '\',0)">Remove</button></div>';
      html += '</div>';
    }
    items.innerHTML = html;

    if (foot) {
      foot.innerHTML = '<div class="cart-drawer__subtotal"><span>Subtotal</span><span>' + money(cart.total_price) + '</span></div>' +
        '<a href="/checkout" class="btn btn--primary btn--full">Secure checkout →</a>' +
        '<a href="/cart" class="btn btn--secondary btn--full" style="margin-top:10px;">View cart</a>' +
        '<div class="cart-drawer__trust">' +
        '<span><svg viewBox="0 0 24 24" fill="none" stroke-width="1.8"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg>Secure</span>' +
        '<span><svg viewBox="0 0 24 24" fill="none" stroke-width="1.8"><path d="M3 12a9 9 0 109-9 9.75 9.75 0 00-6.74 2.74L3 8M3 3v5h5"/></svg>30-day returns</span>' +
        '<span><svg viewBox="0 0 24 24" fill="none" stroke-width="1.8"><path d="M20 6L9 17l-5-5"/></svg>Easy exchanges</span>' +
        '</div>';
    }

    if (shipBar && window.CJP.freeShip) {
      var thr = window.CJP.threshold;
      var remain = thr - cart.total_price;
      if (remain > 0) {
        var pct = Math.min(100, (cart.total_price / thr) * 100);
        shipBar.innerHTML = '<div class="cart-drawer__ship-msg">You\'re <strong>' + money(remain) + '</strong> away from <strong>FREE shipping</strong></div><div class="cart-drawer__ship-bar"><div class="cart-drawer__ship-fill" style="width:' + pct + '%"></div></div>';
      } else {
        shipBar.innerHTML = '<div class="cart-drawer__ship-msg">🎉 <strong>You\'ve unlocked FREE shipping!</strong></div><div class="cart-drawer__ship-bar"><div class="cart-drawer__ship-fill" style="width:100%"></div></div>';
      }
    }
  }

  function updateCount(n) {
    var c = document.getElementById('cart-count');
    if (c) c.textContent = n;
    var m = document.getElementById('mobile-cart-count');
    if (m) { m.textContent = n; m.style.display = n > 0 ? 'flex' : 'none'; }
  }

  /* Global cart API */
  window.CJPCart = {
    add: function (variantId, qty) {
      var btns = document.querySelectorAll('.add-to-cart, .pcard__add, .sticky-buy__btn');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty || 1 })
      }).then(function (r) { return r.json(); })
        .then(function (item) {
          if (item && item.status) { showToast('Could not add — please choose options'); return; }
          showToast('Added to cart ✓');
          if (window.CJP.useDrawer) openDrawer();
          else refreshDrawer();
        }).catch(function () { showToast('Something went wrong'); });
    },
    change: function (key, qty) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); })
        .then(function (cart) {
          renderDrawer(cart);
          if (document.body.className.indexOf('template-cart') > -1) window.location.reload();
        });
    }
  };

  /* Toast */
  function showToast(msg) {
    var t = document.getElementById('cjp-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'cjp-toast';
      t.className = 'cjp-toast';
      document.body.appendChild(t);
    }
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(window._toastTimer);
    window._toastTimer = setTimeout(function () { t.classList.remove('show'); }, 2200);
  }

  /* Product add-to-cart form */
  var pform = document.querySelector('.product-page form');
  if (pform) {
    pform.addEventListener('submit', function (e) {
      e.preventDefault();
      var id = pform.querySelector('[name="id"]').value;
      var qty = pform.querySelector('[name="quantity"]') ? pform.querySelector('[name="quantity"]').value : 1;
      window.CJPCart.add(id, parseInt(qty, 10));
    });
  }

  /* Quantity steppers */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.quantity-btn') : null;
    if (!btn || !btn.dataset.action) return;
    var wrap = btn.closest('.quantity-selector__controls');
    var input = wrap.querySelector('.quantity-input');
    var val = parseInt(input.value, 10) || 1;
    if (btn.dataset.action === 'increase') val++;
    else if (val > 1) val--;
    input.value = val;
  });

  /* Variant selector */
  var productJsonEl = document.getElementById('product-json');
  if (window.productJson) {
    var selected = {};
    document.querySelectorAll('.variant-selector__btn').forEach(function (b) {
      b.addEventListener('click', function () {
        var idx = b.dataset.optionIndex;
        document.querySelectorAll('.variant-selector__btn[data-option-index="' + idx + '"]').forEach(function (x) { x.classList.remove('active'); });
        b.classList.add('active');
        selected[idx] = b.dataset.value;
        matchVariant();
      });
    });
    function matchVariant() {
      var variants = window.productJson.variants;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var k in selected) {
          if (v.options[k] !== selected[k]) { ok = false; break; }
        }
        if (ok) {
          var idInput = document.querySelector('[name="id"]');
          if (idInput) idInput.value = v.id;
          var priceEl = document.querySelector('.product-info__price');
          if (priceEl && v.price != null) priceEl.firstChild.textContent = money(v.price);
          break;
        }
      }
    }
  }

  /* Gallery thumbs */
  document.querySelectorAll('.product-gallery__thumb').forEach(function (t) {
    t.addEventListener('click', function () {
      var idx = t.dataset.index;
      document.querySelectorAll('.product-gallery__item').forEach(function (it, i) {
        it.classList.toggle('active', String(i) === String(idx));
      });
      document.querySelectorAll('.product-gallery__thumb').forEach(function (x) { x.classList.remove('active'); });
      t.classList.add('active');
    });
  });

  /* Hero banner slider */
  (function () {
    var slider = document.getElementById('hero-slider');
    if (!slider) return;
    var slides = slider.querySelectorAll('.hero__slide');
    if (slides.length < 2) return;
    var dots = slider.querySelectorAll('.hero__dot');
    var current = 0, timer;
    var total = slides.length;
    var autoplay = slider.getAttribute('data-autoplay') === 'true';
    var speed = parseInt(slider.getAttribute('data-speed'), 10) || 5000;

    function show(i) {
      slides[current].classList.remove('active');
      if (dots[current]) dots[current].classList.remove('active');
      current = (i + total) % total;
      slides[current].classList.add('active');
      if (dots[current]) dots[current].classList.add('active');
    }
    function next() { show(current + 1); }
    function prev() { show(current - 1); }
    function reset() { if (!autoplay) return; clearInterval(timer); timer = setInterval(next, speed); }

    var nb = document.getElementById('hero-next');
    var pb = document.getElementById('hero-prev');
    if (nb) nb.addEventListener('click', function () { next(); reset(); });
    if (pb) pb.addEventListener('click', function () { prev(); reset(); });
    for (var d = 0; d < dots.length; d++) {
      (function (idx) { dots[idx].addEventListener('click', function () { show(idx); reset(); }); })(d);
    }

    /* touch swipe */
    var startX = 0;
    slider.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    slider.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) { if (dx < 0) next(); else prev(); reset(); }
    }, { passive: true });

    reset();
  })();

  /* Sticky add-to-cart bar — shows after slight scroll, hides while main button is in view */
  var stickyBuy = document.getElementById('sticky-buy');
  var mainAtc = document.querySelector('.product-actions .add-to-cart');
  if (stickyBuy && mainAtc) {
    var syncSticky = function () {
      var r = mainAtc.getBoundingClientRect();
      var mainVisible = r.top < window.innerHeight && r.bottom > 0;
      if (!mainVisible && window.scrollY > 120) stickyBuy.classList.add('show');
      else stickyBuy.classList.remove('show');
    };
    window.addEventListener('scroll', syncSticky);
    window.addEventListener('resize', syncSticky);
    syncSticky();
  }

  /* Scroll reveal — fail-safe so content never stays hidden */
  (function () {
    var els = document.querySelectorAll('.fade-in');
    if (!els.length) return;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('visible'); io.unobserve(en.target); }
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -5% 0px' });
      els.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight) el.classList.add('visible');
        else io.observe(el);
      });
      /* safety net: reveal anything still hidden after 1.2s */
      setTimeout(function () {
        document.querySelectorAll('.fade-in:not(.visible)').forEach(function (el) { el.classList.add('visible'); });
      }, 1200);
    } else {
      els.forEach(function (el) { el.classList.add('visible'); });
    }
  })();

  /* Init mobile cart badge visibility */
  (function () {
    var m = document.getElementById('mobile-cart-count');
    if (m) m.style.display = parseInt(m.textContent, 10) > 0 ? 'flex' : 'none';
  })();
})();